export default __webpack_public_path__ + "static/media/montserrat-bold.93b37a46.ttf";